import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const currentProductsFromSomeoneElseFeatureKey = 'currentProductsFromSomeoneElse';

export interface CurrentProductsFromSomeoneElseState {
  loadCurrentProductsFromSomeoneElseResponse: IProducts[];
  loadCurrentProductsFromSomeoneElseFailure: Error | any;
}

export const initialState: CurrentProductsFromSomeoneElseState = {
  loadCurrentProductsFromSomeoneElseResponse: undefined,
  loadCurrentProductsFromSomeoneElseFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadCurrentProductsFromSomeoneElse, (state, action) => ({
    ...state
  })),
  on(actions.loadCurrentProductsFromSomeoneElseSuccess, (state, action) => ({
    ...state,
    loadCurrentProductsFromSomeoneElseResponse: action.response
  })),
  on(actions.loadCurrentProductsFromSomeoneElseFailure, (state, action) => ({
    ...state,
    loadCurrentProductsFromSomeoneElseFailure: action.error
  }))
);

export const getCurrentProductsFromSomeoneElseResponse = (state: CurrentProductsFromSomeoneElseState) =>
  state.loadCurrentProductsFromSomeoneElseResponse;
